export interface TransactionsRequest {
  transactionsRequest: {
    continuationToken?: string;
  };
}

export interface TransactionsResponse {
  transactions: {
    partStatus: {
      code: TransactionsResponsePartStatusCode;
      versionTimestamp: string;
      continuationToken?: string;
    };
    transactions: Transaction[];
  };
}

export enum TransactionsResponsePartStatusCode {
  SUCCESS = 'SUCCESS',
  RETRY_LATER = 'RETRY_LATER',
  OTHER_ERROR = 'OTHER_ERROR',
}

export enum TransactionStatus {
  PROCESSED = 'Processed',
  CANCELLED = 'Cancelled',
  VERIFIED = 'Verified',
  MANUALLY_CANCELLED = 'Manually Cancelled',
  PARTNER_APPROVED = 'Partner Approved',
  PARTNER_PENDING = 'Partner Pending',
  PARTNER_VERIFIED = 'Partner Verified',
  PARTNER_REJECT = 'Partner Rejected',
}

export interface Transaction {
  awardPoints: string;
  date: string;
  description: string;
  destinationAirport?: string;
  id: string;
  originationAirport?: string;
  flight?: string;
  partnerId: string;
  partnerName: string;
  partnerType?: string;
  productType: TransactionProductType;
  status: TransactionStatus;
  tierPoints: string;
  transactionId: string;
  transactionSubType: string;
  cancelledTxnId?: string;
  ayBookingDate?: string;
  fareFamily?: string;
  productName: string;
  travelClass?: string;
  ticketNumber?: string;
  bookingClass?: string;
  animationOrder?: number;
  isAviosTransaction?: boolean;
}

export enum TransactionProductType {
  AIRLINE_AWARD = 'Airline Award',
  AIRLINE_FLIGHT = 'Airline Flight',
  POINTS_AND_CASH = 'Points + Cash',
  HOTEL_AWARD = 'Hotel Award',
  ELECTRONIC_VOUCHER = 'Electronic Voucher',
  TOUR_OPERATOR = 'Tour Operator',
  OTHER_AWARD = 'Other Award',
  MERCHANDISE = 'Merchandise',
  GOODWILL = 'Goodwill',
  SERVICES = 'Services',
}
